let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jdeAV"), load("7jwEY"), load("2KJHS")]).then(() => parcelRequire('3spmo'));